import { List, ListItem, Row, Typography } from 'darrius';

import styles from './ProfileCertification.module.scss';

interface IProfileCertificationProps {
  certification: {
    id: string;
    title: string;
    items: string[];
  };
}

export const ProfileCertification = ({
  certification,
}: IProfileCertificationProps) => {
  if (!certification) return null;

  return (
    <Row>
      <section className="certification space-top" id={certification.id}>
        <Typography.Subtitle
          size="l"
          className={styles['profile-certification__title']}
        >
          {certification.title}
        </Typography.Subtitle>
        <List className={`certification__list ${styles['list--with-bullet']}`}>
          {certification.items.map((item) => (
            <ListItem key={item}>
              <Typography.Text
                className={styles['profile-certification__list']}
              >
                {item}
              </Typography.Text>
            </ListItem>
          ))}
        </List>
      </section>
    </Row>
  );
};
